import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';

@Component({
    selector: 'shared-forklift-right',
    templateUrl: './shared.forklift.right.component.html',
    styleUrls: ['./shared.forklift.right.component.scss']
})
export class SharedForkliftRightComponent implements OnChanges {

    @Output() public refresh = new EventEmitter<boolean>();
    @Output() public phaseChanged = new EventEmitter<number>();
    @Input() public selectedPhaseId: number | null = null;
    @Input() public accessControlId: number | null = null;
    @Input() public actionsWidth: number = 200;
    @Input() public showDetail: boolean = true;

    public detail: ForkliftRouteDetailDto | null = null;

    constructor(private accessControlController: AccessControlController) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['selectedPhaseId']) {
            this.loadDetail();
        }
    }

    private loadDetail() {
        if (this.selectedPhaseId == null || this.selectedPhaseId === 0) return;
        this.accessControlController.getForkliftRouteDetail(this.selectedPhaseId).subscribe(detail => {
            this.detail = detail;
        });
    }

    onRouteRefresh() {
        this.loadDetail();
        this.refresh.emit(true);
    }

    onPhaseChanged(phaseId: number) {
        this.selectedPhaseId = phaseId;
        this.loadDetail();
        this.phaseChanged.emit(phaseId);
    }
}
